import React from 'react';
import { STATS } from '../mock';

export default function About() {
  return (
    <section id="willkommen" className="relative py-24 md:py-36 px-6 md:px-10">
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-[0.9fr_1.4fr] gap-12 lg:gap-20">
        {/* Left label */}
        <div className="reveal">
          <div className="flex items-center gap-4">
            <span className="h-px w-12 bg-[rgba(224,180,159,0.6)]" />
            <span className="eyebrow">01 — Willkommen</span>
          </div>
        </div>

        {/* Right content */}
        <div>
          <h2 className="reveal font-serif-display font-medium text-[#f2ebe3] text-4xl md:text-6xl leading-[1.05]">
            Wo griechische Gastfreundschaft auf{' '}
            <span className="italic text-[#e0b49f]">fränkische Gemütlichkeit</span> trifft.
          </h2>

          <div className="reveal mt-10 space-y-6 text-[#c3b7aa] text-lg font-light leading-relaxed max-w-2xl">
            <p>
              Warme Natursteinwände, sanftes Licht und der Duft von Holzkohlegrill – das Alfa ist kein gewöhnliches Restaurant. Die Gastgeber waren zuvor sechs Jahre lang im Bistro 1601 in Hilpoltstein zu Hause und bringen diese Leidenschaft nun nach Heideck: ehrliche griechische Küche, zubereitet mit hochwertigen Zutaten und serviert mit Herz.
            </p>
            <p>
              Ob romantisches Abendessen zu zweit, Feier mit Freunden oder ein Glas Wein nach einem langen Tag – bei uns finden Sie den idealen Rahmen für genussvolle Stunden vor Ort.
            </p>
          </div>

          {/* Stats */}
          <div className="reveal mt-14 grid grid-cols-1 sm:grid-cols-3 gap-8">
            {STATS.map((s, i) => (
              <div key={i} className="border-t border-[rgba(224,180,159,0.25)] pt-5">
                <div className="font-serif-display text-[#e0b49f] text-3xl md:text-4xl">{s.value}</div>
                <div className="mt-2 text-[#a99a8b] text-sm leading-snug">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
